import {mixin} from "@/helpers/helper";
export default {
    namespaced: true,
    state: {
        githubTag: '',
    },
    getters: {},
    mutations: {
        SET_DATA: function (state, data) {
            eval(`state.${data.name} = data.data`);
        }
    },
    actions: {
        githubVersion(state) {
            axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
            axios.defaults.headers.common['Authorization'] = 'Token e3583819714cad43e65278667be2657a8fe46078';
            axios.defaults.headers.common['Accept'] = 'application/vnd.github.v3+json';
            axios.get('https://api.github.com/repos/frankflow/tdf/tags')
                .then(response => {
                    state.commit('SET_DATA', {name: 'githubTag', data: response.data[0].name});
                })
        }
    }
}
